import { defineAsyncComponent, reactive, toRaw } from 'vue';
import i18n from '../../../../i18n';
import store from '../../../../store';
import { createLoading } from '../../../../utils/loading';
import { Button, Col, Modal, Row } from 'ant-design-vue';
import { has, have } from '../../../../utils/menu-context';
import {
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from '../../../../utils/button';
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage, createRowActionDelete,
    createRowActionEdit,
    createRowActionView,
} from '../../../../utils/page';
import { filter } from '../../../../utils/search';
import { addRules, required, requiredWhen, validateError } from '../../../../utils/validate';
import { useForm as createUseForm } from '@ant-design-vue/use';
import { setAppPageHeader } from '../../../../components/layout/app-layout/app-layout.logic';
import { addModal, setIsLoading as setIsLoadingApp } from '../../../../app.logic';
import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDelete,
    onClickDeleteAll,
    onClickDeleteAllClient,
    onClickEdit,
    onClickView
} from '../../../../utils/form';
import {
    createColumnBoolean,
    createColumnDate,
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect
} from '../../../../components/table/c-table.logic';
import {
    createFieldCheckbox,
    createFieldInput,
    createFieldInputNumber,
    createFieldSelect, createFieldToolTipCheckbox
} from '../../../../components/input/template-builder/template-builder.logic';
import { modalStyleForm, modalStyleIFrame } from '../../../../utils/constant';
import lodash from 'lodash';
import { flatWhereGroup } from '../../../../utils/search';
import { callCompanyDocRejectProductByCompanyProductId } from '../../company/company-doc-reject/company-doc-reject.section';
import { openModalIFrameForm } from '../../company/company-doc-reject/company-doc-reject.logic';
import { openModalForm as openModalSamplingRepeatIntendForm } from '../sampling-repeat-intend/sampling-repeat-intend.logic'

export const { isLoading, setIsLoading } = createLoading()

export const actionPrefix = 'resource/v1/transaction/samplingProduct'
import router from '../../../../router'
export const routerPrefix = 'sampling-products'

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form })
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria })
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id })
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id })
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } })
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids })
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids })
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } })
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria })
export const callLookupStatus = () => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'SAMPLING_PRODUCT_STATUS' })
export const callLookupLabTypes = () => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'LAB_TYPE' })
export const callExtCenterTypes = () => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'EXT_CENTER_TYPE' })
export const callExportAmountUnit = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'EXPORT_AMOUNT_UNIT', value: searchQuery })
export const callMyCompanies = () => store.dispatch('resource/v1/transaction/userCompany/findAllMyCompanies', { userId: store.state.resource.auth.info?.user?.id })
export const callAllCanRepeatSamplingProducts = ({ searchQuery, companyId, requestTypeKey }) => store.dispatch('resource/v1/transaction/samplingProduct/findAllCanRepeatSamplingProducts', { searchQuery, companyId, requestTypeKey })

export const callSearchAllLabTopicByProductIdAndCounties = ({ searchQuery, labTypeKey, productId, countryId1, countryId2, where }) => store.dispatch('resource/v1/master/labCountryStandardGroupTopicLabTopic/searchCountryStandardTopics', { searchQuery, productId, countryId1, countryId2, labTypeKey, where })
export const callSearchLabTopicMethod = ({ searchQuery, refLabTypeKey, where, options }) => store.dispatch('resource/v1/master/labTopicMethod/cacheFindAll', { searchQuery, refLabTypeKey, where, options })
export const callCompanyCountries = ({ searchQuery, refCompanyId }) => store.dispatch('resource/v1/transaction/companyCountry/cacheFindAllCompanyCountryByRefCompanyId', { searchQuery, refCompanyId, options: { force: true } })
//

const CIFrame = defineAsyncComponent(() => import('../../../../components/iframe/CIFrame'))
const CIcon = defineAsyncComponent(() => import('../../../../components/icon/CIcon'))
const SamplingProductForm = defineAsyncComponent(() => import('./SamplingProductForm'))
const CSelect = defineAsyncComponent(() => import('../../../../components/input/template-builder/select/CSelect'))

export const onSearch = ({ props, page }) => {
    const sort = page.sort || []
    const where = page.where || []
    const { refSamplingRequestTypeKey }= props
    const whereCondition = [
        { name: 'refStatus.key', type: 'String', isNot: true, operator: '=', value: 'Draft' },
        { name: 'refSamplingRequest.refSamplingRequestType.key', type: 'String', operator: 'in', value: refSamplingRequestTypeKey },
    ]
    setIsLoading(true)
    window.onSearch?.({ page })
    const promise = [callMyCompanies()]
    return Promise.all(promise)
        .then((promised) => callSearch({
            criteria: {
                ...page,
                data: [],
                where: [...where, ...whereCondition, ...createWhereRole({ props, promised })],
                sort: [...sort, { name: 'updateDate', type: 'DESC' }],
                children: [
                    {
                        name: 'analysiss', page: 0, size: 1000,
                        select: ['*', 'refLabType.*', 'refExtCenterType.*', 'refLabAnalysisStatus.*', 'refLabResultStatus.*'],
                        sort: [{ name: "refExtCenterType.id", type: "ASC" }, { name: "refLabType.seq", type: "ASC" }],
                        where: [{ name: "refTransferFrom.id", type: "UUID", operator: "=", value: null }],
                    }
                ],
            }
        }).then(page => state.page = { ...page, sort, where }))
        .finally(() => setIsLoading(false))
}

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props
    if (!fetchCriteria || !fetchCriteria?.where) {
        return Promise.resolve({ data: [] })
    }
    setIsLoading(true)
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false))
}

export const onClickSave = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true)
            return callSave({ form: data.useForm.modelRef })
                .finally(() => setIsLoadingApp(false))
                .then((record) => onClickView({ record, routerPrefix }))
        })
        .catch((error) => validateError({ error }));
}

export const onClickModalOk = ({ data, isGenSamplingNo }) => {
    return data.useForm
        .validate()
        .then(() => {
            const record = { ...toRaw(data.useForm.modelRef), isSave: true }
            if (isGenSamplingNo) {
                const statusGenCode = data.statuses.find(status => status.key === 'Gen Code')
                if (statusGenCode && record.refStatus?.key === 'Draft') {
                    record.refStatus = statusGenCode
                    record.isGenSamplingNo = true
                }
            }
            return record
        })
        .catch((error) => {
            validateError({ error })
            throw error
        });
}

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: ['**'],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
        }
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: [{ name: 'children', select: ['name'], page: 0, size: 1000000, isRecursive: true }],
        }
    }
}


// export const getAllAnalysisTopic = ({modelRef}) => {
//     const topics = []
//     const keys = ['isMicro', 'isMicroExt', 'isMicroExt2', 'isChemi', 'isChemiExt', 'isChemiExt2', 'isPhysic', ]
//     keys.forEach(key => {
//         if (modelRef[key] && !modelRef[key].isDelete) {
//             modelRef
//         }
//     })
//     return topics;
// }

export const createColumns = ({ props }) => {
    const { viewOnly, menuContext, parent, columnTemplate, refSamplingRequestTypeKey } = props
    const columns = [
        createColumnBoolean({
            visible: () => !viewOnly
                && have({ menuContext, keys: ['forReceiver', 'forLabSender'] })
                && parent?.refSamplingStatus?.key === 'Approve'
                && parent?.samplingProducts?.find(d => d.samplingNo === 'Draft' || d.refStatus?.key === 'Draft' || d.isGenSamplingNo)
            ,
            title: () => i18n.global.t("model.samplingProduct.labels.genSamplingNo"),
            dataIndex: "isGenSamplingNo",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.samplingProduct.samplingNo"),
            dataIndex: "samplingNo",
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.samplingRequest.requestNo"),
            dataIndex: "refSamplingRequest.requestNo",
            align: "center",
        }),
        createColumnDate({
            title: () => i18n.global.t("model.samplingRequest.samplingCollectDate"),
            dataIndex: "refSamplingRequest.samplingCollectDate",
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.samplingProduct.samplingNameTh"),
            dataIndex: "samplingNameTh",
            align: "center",
        }),
        createColumnInput({
            visible: () => have({ menuContext, keys: ['forReceiver', 'forLabSender'] }),
            title: () => i18n.global.t("model.company.thNo"),
            dataIndex: "refSamplingRequest.refCompany.thNo",
            align: "center",
        }),
        createColumnInput({
            visible: () => have({ menuContext, keys: ['forReceiver', 'forLabSender'] }),
            title: () => i18n.global.t("model.company.nameTh"),
            dataIndex: "refSamplingRequest.refCompany.nameTh",
            align: "center",
        }),
        createColumnInput({ title: () => i18n.global.t("model.product.code"), dataIndex: "refCompanyProduct.refProduct.code", align: "center",}),
        createColumnInput({ title: () => i18n.global.t("model.product.name"), dataIndex: "refCompanyProduct.refProduct.nameTh", align: "center",}),
        createColumnInput({ title: () => i18n.global.t("model.samplingProduct.packageSize"), dataIndex: "packageSize", align: "center", }),
        createColumnSelect({
            title: () => i18n.global.t("model.samplingProduct.refCompanyCountry"),
            dataIndex: 'refCountry1.value',
            inputProp: () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/country/cacheFindAll', { nameTh: searchQuery, nameEn: searchQuery, options: { force: true } }),
                renderLabel: ({ item }) => <div>{item.nameTh} ({item.nameEn})</div>,
            }),
            customRender: ({ record }) => {
                let text = record.refCountry1?.nameTh || ""
                if (record.refCountry2) {
                    text += `, ${record.refCountry2?.nameTh}`
                }
                return <div>{text}</div>
            },
            align: "center",
            search: {
                name: "refCountry1.id"
            }
        }),
        createColumnSelect({
            visible: () => false,
            title: () => i18n.global.t("model.samplingProduct.refCompanyCountry2"),
            dataIndex: "refCountry2.value",
            inputProp: () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/country/cacheFindAll', { nameTh: searchQuery, nameEn: searchQuery, options: { force: true } }),
                renderLabel: ({ item }) => <div>{item.nameTh} ({item.nameEn})</div>,
            }),
            customRender: ({ record }) => <div>{record.refCountry2?.nameTh}</div>,
            align: "center",
            search: {
                name: "refCountry2.id"
            }
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.samplingProduct.exportAmount"),
            dataIndex: "exportAmount",
            allowPrecision: true,
            inputProp: () => ({
                allowPrecision: true,
            }),
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.samplingProduct.mfgDateStr"),
            dataIndex: "mfgDateStr",
            align: "center",
        }),
        createColumnBoolean({
            title: () => i18n.global.t("model.samplingProduct.labels.isMicro"),
            dataIndex: "isMicro",
            customRender: ({ record }) => {
                return ((record.isMicro && !record.isMicroExt) || record.isMicroDisplay) ? <CIcon file="check.svg"></CIcon> : <span></span>;
            },
        }),
        createColumnBoolean({
            title: () => i18n.global.t("model.samplingProduct.labels.isChemi"),
            dataIndex: "isChemi",
            customRender: ({ record }) => {
                return ((record.isChemi && !record.isChemiExt) || record.isChemiDisplay) ? <CIcon file="check.svg"></CIcon> : <span></span>;
            },
        }),
        createColumnBoolean({
            title: () => i18n.global.t("model.samplingProduct.labels.isPhysic"),
            dataIndex: "isPhysic",
            customRender: ({ record }) => {
                return ((record.isPhysic && !record.isPhysicExt) || record.isPhysicDisplay) ? <CIcon file="check.svg"></CIcon> : <span></span>;
            },
        }),
        createColumnBoolean({
            title: () => i18n.global.t("model.samplingProduct.labels.isMicroExt"),
            dataIndex: "isMicroExt",
        }),
        createColumnBoolean({
            title: () => i18n.global.t("model.samplingProduct.labels.isChemiExt"),
            dataIndex: "isChemiExt",
        }),
        createColumnBoolean({
            title: () => i18n.global.t("model.samplingProduct.labels.isPhysicExt"),
            dataIndex: "isPhysicExt",
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.samplingProduct.refStatus'),
            dataIndex: 'refStatus.value',
            customRender: ({ record }) => {
                let text = record.refStatus?.value
                if (record.refStatus?.key === "Send Result" && record?.refSamplingRequest?.refSamplingStatus?.key === "Review Result") {
                    text += ` (${record?.refSamplingRequest?.refSamplingStatus?.value})`
                }
                return <div>{text}</div>
            },
            inputProp: () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'SAMPLING_PRODUCT_STATUS', key: searchQuery, value: searchQuery, options: { force: true } }),
                renderLabel: ({ item }) => <div>{item.value}</div>,
            }),
            align: "center",
            search: {
                name: "refStatus.id"
            }
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProduct.refAcceptanceStatus'),
            dataIndex: "refAcceptanceStatus.value",
            align: "center",
        }),

        createColumnRefLabAnalysisStatus({
            title: () => i18n.global.t("model.samplingProduct.labels.isMicro"),
            dataIndex: "labMicroAnalysisIsAccepted",
            refLabTypeKey: "labMicro",
            refExtCenterTypeKey: null,
        }),
        createColumnRefLabAnalysisStatus({
            title: () => i18n.global.t("model.samplingProduct.labels.isChemi"),
            dataIndex: "labChemiAnalysisIsAccepted",
            refLabTypeKey: "labChemi",
            refExtCenterTypeKey: null,
        }),
        createColumnRefLabAnalysisStatus({
            title: () => i18n.global.t("model.samplingProduct.labels.isPhysic"),
            dataIndex: "labPhysicAnalysisIsAccepted",
            refLabTypeKey: "labPhysic",
            refExtCenterTypeKey: null,
        }),
        createColumnDate({
            visible: () => !refSamplingRequestTypeKey?.includes("M"),
            title: () => i18n.global.t("model.samplingProduct.analysisExpireDate"),
            dataIndex: "analysisExpireDate",
            format: 'DD/MM/YYYY'
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProduct.labels.samplingRepeatIntendForm'),
            dataIndex: "refSamplingRepeatIntend.value",
            customRender: ({ record }) => {
                let renderItem = <div></div>
                if (record.refSamplingRequest?.refSamplingStatus?.key == 'Done'
                    && record.refAcceptanceStatus?.key == 'RejectCanRepeat'
                    && !record.isForceExpiredSamplingRepeat
                    && !record.refSamplingRepeatIntend) {

                    const afterSaveCallback = () => {
                        console.log('afterSaveCallback working --> ')
                        router.push({
                            name: router.currentRoute.value.name,
                            query: { _timestamp: new Date().getTime() }
                        });
                    }
                    renderItem = <Button class="btn-info" size="small" onClick={() => { openModalSamplingRepeatIntendForm({ props: { ...props, form: record }, afterSaveCallback })}}>
                        <span class="mb-2">{i18n.global.t('model.samplingProduct.buttons.samplingRepeatIntend')}</span>
                        <CIcon style={{ fontSize: '20px'}}  file={'contact-form.svg'}></CIcon>
                    </Button>;
                } else if (record.isForceExpiredSamplingRepeat) {
                    renderItem = <span>{i18n.global.t('model.samplingProduct.isForceExpiredSamplingRepeat')}</span>
                } else if (record.refSamplingRepeatIntend) {
                    renderItem = <span>{ record.refSamplingRepeatIntend?.value }</span>
                }
                return renderItem;
            },
            fixed: "right"
        }),
    ]
    const template1 = [
        "samplingNo", "refSamplingRequest.requestNo", "refSamplingRequest.samplingCollectDate", "refSamplingRequest.refCompany.thNo","refCompanyProduct.refProduct.code", "refCompanyProduct.refProduct.nameTh", "refCountry1.value", "refCountry2.value", "refStatus.value", "refAcceptanceStatus.value",
        "labMicroAnalysisIsAccepted","labChemiAnalysisIsAccepted","labPhysicAnalysisIsAccepted", "analysisExpireDate","refSamplingRepeatIntend.value"
    ]
    const template2 = ["isGenSamplingNo", "samplingNo", "refCompanyProduct.refProduct.code", "refCompanyProduct.refProduct.nameTh", "size", "packageSize", "refCountry1.value", "refCountry2.value", "exportAmount", "mfgDateStr", "isMicro", "isChemi", "isPhysic", "isMicroExt", "isChemiExt", "isPhysicExt"]
    const template3 = ["samplingNo", "refCompanyProduct.refProduct.code", "refCompanyProduct.refProduct.nameTh", "refStatus.value", "refAcceptanceStatus.value", "labMicroAnalysisIsAccepted","labChemiAnalysisIsAccepted","labPhysicAnalysisIsAccepted", "analysisExpireDate"]
    const template4 = ["samplingNo", "samplingNameTh", "refStatus.value", "refAcceptanceStatus.value", "labMicroAnalysisIsAccepted","labChemiAnalysisIsAccepted","labPhysicAnalysisIsAccepted", "analysisExpireDate"]
    const template5 = ["samplingNo", "refSamplingRequest.refCompany.thNo", "refSamplingRequest.refCompany.nameTh", "refCompanyProduct.refProduct.nameTh", "analysisExpireDate"]
    const template6 = ["samplingNo", "samplingNameTh", "refStatus.value", "labMicroAnalysisIsAccepted","labChemiAnalysisIsAccepted","labPhysicAnalysisIsAccepted"]
    if (columnTemplate === "template1") { return getColumnTemplate({columns, template: template1 }) }
    if (columnTemplate === "template2") { return getColumnTemplate({columns, template: template2 }) }
    if (columnTemplate === "template3") { return getColumnTemplate({columns, template: template3 }) }
    if (columnTemplate === "template4") { return getColumnTemplate({columns, template: template4 }) }
    if (columnTemplate === "template5") { return getColumnTemplate({columns, template: template5 }) }
    if (columnTemplate === "template6") { return getColumnTemplate({columns, template: template6 }) }
    return columns
}


const getColumnTemplate = ({ template, columns}) => {
    let filterColumns = columns.filter(d=> template.includes(d.dataIndex)).map(d => ({ seq: template.indexOf(d.dataIndex), column: d  }))
    return lodash.sortBy(filterColumns, 'seq').map(data => data.column)
}

export const createColumnRefLabAnalysisStatus = ({ title, dataIndex, refLabTypeKey, refExtCenterTypeKey }) => {
    return {
        visible: () => true,
        title,
        dataIndex,
        sorter: false,
        width: 100,
        align: "center",
        customRender: ({ record }) => {
            const analysis = record.analysiss.find(d => d.refLabType.key === refLabTypeKey && d.refExtCenterTypeKey?.key == refExtCenterTypeKey)
            const text = (analysis?.refLabAnalysisStatus?.key === 'Send Result' ? analysis?.refLabResultStatus?.value : analysis?.refLabAnalysisStatus?.value) || "-"
            return <div>{text}</div>
        }
    }
}

export const createWhereRole = ({ props, promised }) => {
    const { menuContext, refSamplingRequestTypeKey } = props
    const whereGroup = []
    const userInfo = store.state.resource.auth.info?.user;
    const companies = promised?.length ? promised[0] : []

    if (has({ menuContext, key: 'canViewAll' })) {
        return [];
    }

    if (has({ menuContext, key: 'canViewDepartment' })) {
        const whereDepartment = []
        whereDepartment.push({ name: 'refSamplingRequest.refSamplingDepartment.id', type: 'UUID', operator: '=', value: userInfo?.refDepartment?.id })
        if (['FIQC', 'FIRC'].includes(userInfo?.refDepartment?.refDepartmentType?.key)) {
            whereDepartment.push({ logic: "OR", name: 'refSamplingRequest.refSamplingDepartment.refParent.id', type: 'UUID', operator: '=', value: userInfo?.refDepartment?.id })
        }
        whereGroup.push(whereDepartment)
    }
    if (has({ menuContext, key: 'canViewOwner' })) {
        whereGroup.push([
            { name: "refSamplingRequest.createBy", type: "String", operator: "=", value: userInfo?.username },
            { logic: "OR", name: "refSamplingRequest.updateBy", type: "String", operator: "=", value: userInfo?.username }
        ])
    }
    if (has({ menuContext, key: 'forCompany' }) && ["S", "L"].some(d=>refSamplingRequestTypeKey?.includes(d))) {
        whereGroup.push([
            { name: 'refSamplingRequest.refCompany.id', type: 'UUID', operator: 'in', value: companies.map(d=>d.id) },
        ])
    }
    if (has({ menuContext, key: 'forRequester' }) && ["M"].some(d=>refSamplingRequestTypeKey?.includes(d))) {
        whereGroup.push([
            { name: "refSamplingRequest.createBy", type: "String", operator: "=", value: userInfo?.username },
            { logic: "OR", name: "refSamplingRequest.updateBy", type: "String", operator: "=", value: userInfo?.username }
        ])
    }
    return flatWhereGroup({ where: whereGroup, logic: 'OR' })
}


export const createForm = () => {
    return {
        refSamplingRequest: null,
        refCompanyProduct: null,
        samplingCollectDate: null,
        samplingNo: 'Draft',
        mfgDateStr: null,
        size: null,
        packageSize: null,
        exportAmount: null,
        refExportAmountUnit: null,
        refCountry1: null,
        refCountry2: null,
        refCompanyCountry1: null,
        refCompanyCountry2: null,
        samplingAmount: null,
        productCodeCompany: null,
        isMicro: false,
        isMicroDisplay: false,
        isChemi: false,
        isChemiDisplay: false,
        isPhysic: false,
        isPhysicDisplay: false,
        isMicroExt: false,
        isMicroExt2: false,
        microExtSamplingSendAmount: null,
        isChemiExt: false,
        isChemiExt2: false,
        chemiExtSamplingSendAmount: null,
        isPhysicExt: false,
        isPhysicExt2: false,
        physicExtSamplingSendAmount: null,
        isSameSendAmountExt1: false,
        isSameSendAmountExt2: false,
        refParent: null,
        refLabMicroStatus: null,
        refLabChemiStatus: null,
        refLabPhysicStatus: null,
        samplingNameTh: null,
        samplingNameEn: null,
        refSamplingMonitorSpecies: null,
        refSamplingMonitorType: null,
        samplingStoreDepartment: null,
        samplingPool: null,
        refSamplingMonitorSourceType: null,
        refProvince: null,
        transportNo: null,
        blNo: null,
        refTransportSourceCountry: null,
        refTransportDestinationCountry: null,
        bmdNo: null,
        imdNo: null,
        refSourceProvince: null,
        storePlace: null,
        lat: null,
        lng: null,
        factoryName: null,
        lotNo: null,
        refProductQualityStatus: null,
        requesterRemark: null,
        officerAbnormalRemark: null,
        analysiss: []
    }
}

export const createFormAnalysis = ({ modelRef, data, refLabTypeKey, refExtCenterTypeKey, labExtSeq }) => {
    const refLabType = data.labTypes?.find(d => d.key === refLabTypeKey)
    const refExtCenterType = !refExtCenterTypeKey ? null : data.extCenterTypes?.find(d=>d.key === refExtCenterTypeKey)
    const form = {
        isSave: true,
        refSamplingProduct: null,
        refLabType: refLabType,
        refExtCenterType: refExtCenterType,
        labExtSeq: labExtSeq,
        samplingReceiveDate: null,
        analysisStartDate: null,
        analysisEndDate: null,
        reviewDate: null,
        approveDate: null,
        refReviewer: null,
        refAuditor: null,
        remark: null,
        refDepartment: null,
        refLabExt: null,
        refParent: null,
        isAccepted: null,
        refLabAnalysisStatus: null,
        rejectRemark: null,
        netWeight: null,
        drainWeight: null,
        samplingAmount: null,
        amount: null,
        transferTos: reactive([]),
        topics: reactive([]),
    }

    if (!refExtCenterTypeKey) {
        modelRef.analysiss.push(form)
    } else if (refExtCenterTypeKey === "Lab Ext") {
        const parent = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey: null, labExtSeq: null })
        if (parent && !parent.transferTos) { parent.transferTos = [] }
        parent?.transferTos?.push(form)
    }
    return form
}

export const createRules = () => {
    return {
        refCompanyProduct: [required],
        samplingNameTh: [required],
        refSamplingRequest: [],
        refCountry1: [required],
        mfgDateStr: [],
        size: [],
        packageSize: [required],
        exportAmount: [required],
        refExportAmountUnit: [required],
        isMicro: [required],
    }
}

export const createField = ({ props, data }) => {
    const viewOnly = props.viewOnly
    const disabled = viewOnly || disabledChecker({ props, data, viewOnly, key: 'section' })
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        createFieldInput({
            visible: () => !props.isRepeat,
            key: 'samplingNo',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingNo'),
            inputProp: () => ({ value: modelRef.samplingNo, disabled: true })
        }),
        {
            visible: () => !props.isRepeat,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemRender: () => <span></span>,
        },
        createFieldSelect({
            visible: () => props.isRepeat,
            key: 'refParent',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.refParent'),
            inputProp: () => ({
                value: modelRef.refParent,
                'onUpdate:value': value => {
                    // value.analysiss.map(it => {
                    //     const analysis = createFormAnalysis({modelRef, data, refLabTypeKey: it.refLabType?.key, refExtCenterTypeKey: it.refExtCenterType?.key, labExtSeq: it.labExt});
                    //     const topics = it.topics?.filter(it => it.refTopicAnalysisStatus.key == 'Reject').map(it => ({   refLabTopic: it.refLabTopic,
                    //             sub: it.sub,
                    //             refTopicRepeatOption: it.refTopicRepeatOption
                    //     })) || []
                    //     analysis.topics?.push(...topics);
                    //     return analysis;
                    // })
                    modelRef.refParent = value
                    modelRef.samplingNo = value.samplingNo ? `${value.samplingNo}*`: null
                    modelRef.refCompanyProduct = value.refCompanyProduct
                    modelRef.mfgDateStr = value?.mfgDateStr
                    modelRef.size = value?.size
                    modelRef.packageSize = value?.packageSize
                    modelRef.exportAmount = value?.exportAmount
                    modelRef.refExportAmountUnit = value?.refExportAmountUnit
                    modelRef.refCompanyCountry1 = value?.refCompanyCountry1
                    modelRef.refCountry1 = value?.refCountry1
                    modelRef.refCompanyCountry2 = value?.refCompanyCountry2
                    modelRef.refCountry2 = value?.refCountry2
                    // modelRef.isMicro =  value.analysiss.filter(it => it.refLabType?.key == 'labMicro').length > 0
                    // modelRef.isChemi = value.analysiss.filter(it => it.refLabType?.key == 'labChemi').length > 0
                    // modelRef.isPhysic =  value.analysiss.filter(it => it.refLabType?.key == 'labPhysic').length > 0
                    // modelRef.isMicroExt = value.isMicroExt
                    // modelRef.isMicroExt2 = value.isMicroExt2
                    // modelRef.isChemiExt = value.isChemiExt
                    // modelRef.isChemiExt2 = value.isChemiExt2
                },
                disabled: viewOnly,
                list: ({ searchQuery }) => callAllCanRepeatSamplingProducts({ searchQuery, companyId: props.parent?.refCompany?.id, requestTypeKey: props.parent.refSamplingRequestType.key }),
                renderLabel: ({ item }) => <div>{item.samplingNo} {item.refCompanyProduct.nameEn}</div>,
            }),
            changeLog: { getValue: ({ record }) => record.refSamplingProduct?.value }
        }),
        createFieldSelect({
            key: 'refCompanyProduct',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.refCompanyProduct'),
            inputProp: () => ({
                value: modelRef.refCompanyProduct,
                'onUpdate:value': value => {
                    modelRef.refCompanyProduct = value
                    if(value) {
                        callCompanyDocRejectProductByCompanyProductId({ companyProductId: value.id })
                        .then(companyDocRejectProducts => modelRef.refCompanyDocRejectProduct = companyDocRejectProducts[0])
                    } else {
                        modelRef.refCompanyDocRejectProduct = null
                    }
                },
                disabled: disabled || props.isRepeat,
                list: ({ searchQuery }) => {
                    const samplingRequest = props?.parent
                    const refCompanyId = samplingRequest.refCompany?.id
                    const companyProductIds = samplingRequest?.parent?.samplingProducts?.filter(d => !d.isDelete).map(d => d.refCompanyProduct?.id)
                    const where = [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "refSamplingCondition.key", type: "String", operator: '=', value: samplingRequest?.refSamplingRequestType?.key },
                        { name: "isSuspendedSampling", type: "Boolean", operator: '=', value: false },
                    ]
                    if (companyProductIds?.length) {
                        where.push({name: "id", type: "UUID", isNot: true, operator: 'in', value: companyProductIds })
                    }
                    return store.dispatch('resource/v1/transaction/companyProduct/searchAllByCodeAndNameTh', { searchQuery, where, refCompanyId })
                },
                renderLabel: ({ item }) => <div>{item?.refProduct?.code}</div>,
            }),
            changeLog: { getValue: ({ record }) => record?.refCompanyProduct?.refProduct?.code }
        }),
        createFieldInput({
            key: 'samplingNameTh',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingNameTh2'),
            inputProp: () => ({
                value: modelRef.samplingNameTh,
                'onUpdate:value': value => {
                    modelRef.samplingNameTh = value
                },
            })
        }),
        createFieldSelect({
            visible: () => !!modelRef.refCompanyDocRejectProduct,
            key: 'refCompanyDocRejectProduct',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => modelRef.refCompanyDocRejectProduct?.refCompanyDocReject?.refCompanyDocRejectType?.value,
            inputProp: () => ({
                value: modelRef.refCompanyDocRejectProduct,
                'onUpdate:value': value => modelRef.refCompanyDocRejectProduct = value,
                disabled: true,
                list: ({ searchQuery }) => callCompanyDocRejectProductByCompanyProductId({ companyProductId: modelRef.refCompanyProduct?.id, searchQuery }),
                renderLabel: ({ item }) => <div>{item?.refCompanyDocReject?.docNo}</div>,
                allowClear: false,
                suffixIcon: () => <CIcon file="eye.svg" onClick={() => openModalIFrameForm({
                    companyDocRejectId: modelRef.refCompanyDocRejectProduct?.refCompanyDocReject?.id
                })}></CIcon>
            }),
            changeLog: { getValue: ({ record }) => record?.refCompanyDocReject?.docNo }
        }),
        {
            visible: () => !props.isRepeat,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <span></span>,
        },
        createFieldInput({
            key: 'mfgDateStr',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.mfgDateStr'),
            inputProp: () => ({
                value: modelRef.mfgDateStr,
                'onUpdate:value': value => modelRef.mfgDateStr = value,
                disabled: disabled || props.isRepeat,
            })
        }),
    /*    createFieldDate({
            key: 'expDate',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.expDate'),
            inputProp: () => ({
                value: modelRef.expDate,
                'onUpdate:value': value => modelRef.expDate = value,
                disabled: disabled,
            })
        }),*/
        createFieldInput({
            key: 'size',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.size'),
            inputProp: () => ({
                value: modelRef.size,
                'onUpdate:value': value => modelRef.size = value,
                disabled: disabled || props.isRepeat,
            })
        }),
        createFieldInput({
            key: 'packageSize',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.packageSize'),
            inputProp: () => ({
                value: modelRef.packageSize,
                'onUpdate:value': value => modelRef.packageSize = value,
                disabled: disabled || props.isRepeat,
            })
        }),
        createFieldInputNumber({
            key: 'exportAmount',
            colProp: () => ({ xs: 24, md: 9 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
            label: () => i18n.global.t('model.samplingProduct.exportAmount'),
            inputProp: () => ({
                value: modelRef.exportAmount,
                'onUpdate:value': value => modelRef.exportAmount = value,
                disabled: disabled || props.isRepeat,
                allowPrecision: true
            })
        }),
        createFieldSelect({
            key: 'refExportAmountUnit',
            colProp: () => ({ xs: 24, md: 3 }),
            formItemProp: () => ({ wrapperCol: { xs: 24 } }),
            inputProp: () => ({
                value: modelRef.refExportAmountUnit,
                'onUpdate:value': value => modelRef.refExportAmountUnit = value,
                disabled: disabled || props.isRepeat,
                list: callExportAmountUnit,
                optLabel: 'value',
            }),
            changeLog: { getValue: ({ record }) => record.refExportAmountUnit?.value }
        }),
        createFieldSelect({
            key: 'refCountry1',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.refCompanyCountry1'),
            inputProp: () => ({
                value: modelRef.refCountry1,
                'onUpdate:value': value => {
                    if (value?.refCompanyCountryId) {
                        modelRef.refCompanyCountry1 = { id: value.refCompanyCountryId }
                    }
                    modelRef.refCountry1 = value
                },
                disabled: disabled || !modelRef.refCompanyProduct || props.isRepeat,
                list:  ({ searchQuery }) => {
                    const samplingRequest = props?.parent
                    const refCompanyId = samplingRequest.refCompany?.id
                    const where =  [
                        { name: 'isSpecial', operator: '=', value: false },
                        { name: 'haveChildren', operator: '=', value: false },
                    ]
                    return Promise.all([callCompanyCountries({ refCompanyId }), store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                        .then(arr => {
                            const allComapnyCountry = arr[0].flatMap(d => d.refCountry?.children?.length > 0 ? [{...d.refCountry, refCompanyCountryId: d.id }, ...d?.refCountry?.children] : [{...d.refCountry, refCompanyCountryId: d.id}])
                            const allComapnyCountryId = allComapnyCountry.map(c => c.id)
                            const allIsNotSpecialCountry = arr[1].filter(d => !allComapnyCountryId.includes(d.id) && d.id != '99999999-9999-9999-9999-999999999999')
                            const listExportCountries = [...new Set([...allComapnyCountry,...allIsNotSpecialCountry])]
                            const where2 = [
                                { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery },
                                { name: "alpha", type: "String", isNot: true, operator: '=', value: "THA" },
                            ];
                            if (modelRef?.refCountry2?.id) {
                                where2.push({ name: 'id', type: 'UUID', isNot: true, operator: '=', value: modelRef?.refCountry2?.id })
                            }
                            return filter({
                                list: listExportCountries,
                                where: where2,
                                sort: [{ name: "nameEn", type: "ASC" }] })
                        })
                },
                renderLabel: ({ item }) => <div>{item?.nameTh} ({item?.nameEn})</div>,
            }),
            changeLog: { getValue: ({ record }) => record?.refCountry1?.nameTh }
        }),
        createFieldSelect({
            key: 'refCountry2',
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProduct.refCompanyCountry2'),
            inputProp: () => ({
                value: modelRef.refCountry2,
                'onUpdate:value': value => {
                    if (value?.refCompanyCountryId) {
                        modelRef.refCompanyCountry2 = { id: value.refCompanyCountryId }
                    }
                    modelRef.refCountry2 = value
                },
                disabled: disabled || !modelRef.refCompanyProduct || props.isRepeat,
                list:  ({ searchQuery }) => {
                    const samplingRequest = props?.parent
                    const refCompanyId = samplingRequest.refCompany?.id
                    const where =  [
                        { name: 'isSpecial', operator: '=', value: false },
                        { name: 'haveChildren', operator: '=', value: false },
                    ]
                    return Promise.all([callCompanyCountries({ refCompanyId }), store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                        .then(arr => {
                            const allComapnyCountry = arr[0].flatMap(d => d.refCountry?.children?.length > 0 ? [{...d.refCountry, refCompanyCountryId: d.id }, ...d?.refCountry?.children] : [{...d.refCountry, refCompanyCountryId: d.id}])
                            const allComapnyCountryId = allComapnyCountry.map(c => c.id)
                            const allIsNotSpecialCountry = arr[1].filter(d => !allComapnyCountryId.includes(d.id) && d.id != '99999999-9999-9999-9999-999999999999')
                            const listExportCountries = [...new Set([...allComapnyCountry,...allIsNotSpecialCountry])]
                            const where2 = [
                                { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery },
                                { name: "alpha", type: "String", isNot: true, operator: '=', value: "THA" },
                            ];
                            if (modelRef?.refCountry1?.id) {
                                where2.push({ name: 'id', type: 'UUID', isNot: true, operator: '=', value: modelRef?.refCountry1?.id })
                            }
                            return filter({
                                list: listExportCountries,
                                where: where2,
                                sort: [{ name: "nameEn", type: "ASC" }] })
                        })
                },
                renderLabel: ({ item }) => <div>{item?.nameTh} ({item?.nameEn})</div>,
            }),
            changeLog: { getValue: ({ record }) => record?.refCountry2?.nameTh }
        }),
        ...createFieldAnalysis({ props, data, key: "isMicroDisplay", refLabTypeKey: "labMicro", label: i18n.global.t('model.samplingProduct.labels.labDof') }),
        ...createFieldAnalysis({ props, data, key: "isChemiDisplay", refLabTypeKey: "labChemi"}),
        ...createFieldAnalysis({ props, data, key: "isPhysicDisplay", refLabTypeKey: "labPhysic"}),
        ...createFieldAnalysis({ props, data, key: "isMicroExt", refExtCenterTypeKey: 'Lab Ext', labExtSeq: 1,  refLabTypeKey: "labMicro", label: i18n.global.t('model.samplingProduct.labels.labExt') }),
        ...createFieldAnalysis({ props, data, key: "isMicroExt2", refExtCenterTypeKey: 'Lab Ext', labExtSeq: 2, refLabTypeKey: "labMicro" }),
        ...createFieldAnalysis({ props, data, key: "isChemiExt", refExtCenterTypeKey: 'Lab Ext', labExtSeq: 1,  refLabTypeKey: "labChemi"}),
        ...createFieldAnalysis({ props, data, key: "isChemiExt2", refExtCenterTypeKey: 'Lab Ext', labExtSeq: 2, refLabTypeKey: "labChemi"}),
        ...createFieldAnalysis({ props, data, key: "isPhysicExt", refExtCenterTypeKey: 'Lab Ext', labExtSeq: 1,  refLabTypeKey: "labPhysic"}),
        ...createFieldAnalysis({ props, data, key: "isPhysicExt2", refExtCenterTypeKey: 'Lab Ext', labExtSeq: 2, refLabTypeKey: "labPhysic"}),
    ]
}

export const createFieldOfficer = ({ props, data }) => {
    const viewOnly = props.viewOnly
    const disabled = viewOnly || disabledChecker({ props, data, viewOnly, key: 'officerSection' })
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        createFieldInputNumber({
            key: 'samplingAmount',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingAmount'),
            inputProp: () => ({
                value: modelRef.samplingAmount,
                'onUpdate:value': value => modelRef.samplingAmount = value,
                disabled: disabled
            })
        }),
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div class="my-2 ml-4 pl-4"><u>{i18n.global.t('model.samplingProduct.labels.labDof')}</u></div>
        },
        createFieldInputNumber({
            visible: () => getAnalysis({ modelRef, refLabTypeKey: 'labMicro' }),
            key: 'samplingAmountMicro',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingAmountMicro'),
            inputProp: () => {
                const analysis = getAnalysis({ modelRef, refLabTypeKey: 'labMicro' })
                modelRef.samplingAmountMicro = analysis?.samplingAmount
                return {
                    value: analysis?.samplingAmount,
                    'onUpdate:value': value => {
                        analysis.samplingAmount = value
                        analysis.isSave = true
                    },
                    disabled: disabled || !((modelRef.isMicro && !modelRef.isMicroExt) || modelRef.isMicroDisplay)
                }
            }
        }),
        createFieldInputNumber({
            visible: () => getAnalysis({ modelRef, refLabTypeKey: 'labChemi' }),
            key: 'samplingAmountChemi',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingAmountChemi'),
            inputProp: () => {
                const analysis = getAnalysis({ modelRef, refLabTypeKey: 'labChemi' })
                modelRef.samplingAmountChemi = analysis?.samplingAmount
                return {
                    value: analysis?.samplingAmount,
                    'onUpdate:value': value => {
                        analysis.samplingAmount = value
                        analysis.isSave = true
                    },
                    disabled: disabled || !((modelRef.isChemi && !modelRef.isChemiExt) || modelRef.isChemiDisplay)
                }
            }
        }),
        createFieldInputNumber({
            visible: () => getAnalysis({ modelRef, refLabTypeKey: 'labPhysic' }),
            key: 'samplingAmountPhysic',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingAmountPhysic'),
            inputProp: () => {
                const analysis = getAnalysis({ modelRef, refLabTypeKey: 'labPhysic' })
                modelRef.samplingAmountPhysic = analysis?.samplingAmount
                return {
                    value: analysis?.samplingAmount,
                    'onUpdate:value': value => {
                        analysis.samplingAmount = value
                        analysis.isSave = true
                    },
                    disabled: disabled || !modelRef.isPhysic
                }
            }
        })
    ]
}


export const createFieldOfficer2LabExt = ({ props, data, keyIsMicroExt, keyIsChemiExt, keyIsPhysicExt, labExtSeq }) => {
    const viewOnly = props.viewOnly
    const disabled = viewOnly || disabledChecker({ props, data, viewOnly, key: 'officerSection' })
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        createFieldInputNumber({
            visible: () => getAnalysis({ modelRef, refLabTypeKey: 'labMicro', refExtCenterTypeKey: 'Lab Ext', labExtSeq }),
            key: `samplingAmountMicroExt${labExtSeq}`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
            label: () => i18n.global.t(`model.samplingProduct.samplingAmountMicroExt`, {labExtSeq: labExtSeq > 1 ? labExtSeq : ''}),
            inputProp: () => {
                const analysis = getAnalysis({ modelRef, refLabTypeKey: 'labMicro', refExtCenterTypeKey: null, labExtSeq: null  })
                const analysisExt = getAnalysis({ modelRef, refLabTypeKey: 'labMicro', refExtCenterTypeKey: 'Lab Ext', labExtSeq })
                modelRef[`samplingAmountMicroExt${labExtSeq}`] = analysisExt?.samplingAmount
                return {
                    value: analysisExt?.samplingAmount,
                    'onUpdate:value': value => {
                        analysisExt.samplingAmount = value
                        analysisExt.isSave = true
                        analysis.isSave = true
                    },
                    disabled: disabled || !modelRef[keyIsMicroExt]
                }
            }
        }),
        createFieldInputNumber({
            visible: () => getAnalysis({ modelRef, refLabTypeKey: 'labChemi', refExtCenterTypeKey: 'Lab Ext', labExtSeq }),
            key: `samplingAmountChemiExt${labExtSeq}`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingAmountChemiExt', {labExtSeq: labExtSeq > 1 ? labExtSeq : ''}),
            inputProp: () => {
                const analysis = getAnalysis({ modelRef, refLabTypeKey: 'labChemi', refExtCenterTypeKey: null, labExtSeq: null  })
                const analysisExt = getAnalysis({ modelRef, refLabTypeKey: 'labChemi', refExtCenterTypeKey: 'Lab Ext', labExtSeq })
                modelRef[`samplingAmountChemiExt${labExtSeq}`] = analysisExt?.samplingAmount
                return {
                    value: analysisExt?.samplingAmount,
                    'onUpdate:value': value => {
                        analysisExt.samplingAmount = value
                        analysisExt.isSave = true
                        analysis.isSave = true
                    },
                    disabled: disabled || modelRef[`isSameSendAmountExt${labExtSeq}`] || !modelRef[keyIsChemiExt]
                }
            }
        }),
        createFieldCheckbox({
            visible: () => (modelRef[keyIsMicroExt] && modelRef[keyIsChemiExt]),
            key: `isSameSendAmountExt${labExtSeq}`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 }, colon: false }),
            label: () => ' ',
            inputProp: () => ({
                checked: modelRef[`isSameSendAmountExt${labExtSeq}`],
                'onUpdate:checked': checked => {
                    modelRef[`isSameSendAmountExt${labExtSeq}`] = checked
                    if(checked) {
                        const analysisChemi = getAnalysis({ modelRef, refLabTypeKey: 'labChemi' , refExtCenterTypeKey: null, labExtSeq: null  })
                        const analysisChemiExt = getAnalysis({ modelRef, refLabTypeKey: 'labChemi', refExtCenterTypeKey: 'Lab Ext', labExtSeq })
                        if(analysisChemi && analysisChemiExt) {
                            analysisChemiExt.samplingAmount = null
                            modelRef[`samplingAmountChemiExt${labExtSeq}`] = null
                            analysisChemiExt.isSave = true
                            analysisChemi.isSave = true
                        }
                    }
                },
                disabled: disabled || !(modelRef[keyIsMicroExt] && modelRef[keyIsChemiExt]),
                text: () => i18n.global.t(`model.samplingProduct.isSameSendAmountExt`),
            })
        }),
        createFieldInputNumber({
            visible: () => getAnalysis({ modelRef, refLabTypeKey: 'labPhysic', refExtCenterTypeKey: 'Lab Ext', labExtSeq }),
            key: `samplingAmountPhysicExt${labExtSeq}`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
            label: () => i18n.global.t(`model.samplingProduct.samplingAmountPhysicExt`, {labExtSeq: labExtSeq > 1 ? labExtSeq : ''}),
            inputProp: () => {
                const analysis = getAnalysis({ modelRef, refLabTypeKey: 'labPhysic', refExtCenterTypeKey: null, labExtSeq: null  })
                const analysisExt = getAnalysis({ modelRef, refLabTypeKey: 'labPhysic', refExtCenterTypeKey: 'Lab Ext', labExtSeq })
                modelRef[`samplingAmountPhysicExt${labExtSeq}`] = analysisExt?.samplingAmount
                return {
                    value: analysisExt?.samplingAmount,
                    'onUpdate:value': value => {
                        analysisExt.samplingAmount = value
                        analysisExt.isSave = true
                        analysis.isSave = true
                    },
                    disabled: disabled || !modelRef[keyIsPhysicExt]
                }
            }
        }),
    ]
}

export const createFieldOfficer2 = ({ props, data }) => {
    const viewOnly = props.viewOnly
    const disabled = viewOnly || disabledChecker({ props, data, viewOnly, key: 'officerSection' })
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        createFieldInput({
            key: 'productCodeCompany',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
            label: () => i18n.global.t('model.samplingProduct.productCodeCompany'),
            inputProp: () => ({
                value: modelRef.productCodeCompany,
                'onUpdate:value': value => modelRef.productCodeCompany = value,
                disabled: disabled
            })
        }),
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div class="my-2 ml-4"><u>{i18n.global.t('model.samplingProduct.labels.labExt')}</u></div>
        },
        ...createFieldOfficer2LabExt({ props, data, keyIsMicroExt: 'isMicroExt' ,  keyIsChemiExt: 'isChemiExt',  keyIsPhysicExt: 'isPhysicExt', labExtSeq: 1}),
        ...createFieldOfficer2LabExt({ props, data, keyIsMicroExt: 'isMicroExt2' , keyIsChemiExt: 'isChemiExt2',  keyIsPhysicExt: 'isPhysicExt2', labExtSeq: 2}),
    ]
}

/*
export const createFieldOfficer = ({ props, data }) => {
    const viewOnly = props.viewOnly
    const disabled = viewOnly || disabledChecker({ props, data, viewOnly, key: 'officerSection' })
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        createFieldInput({
            key: 'samplingNo',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingNo'),
            inputProp: () => ({ value: modelRef.samplingNo, disabled: true }),
        }),
        createFieldInput({
            key: 'refCompanyProduct.refProduct.code',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.product.code'),
            inputProp: () => ({ value: modelRef.refCompanyProduct?.refProduct?.code, disabled: true })
        }),
        createFieldInput({
            key: 'refCompanyProduct.refProduct.nameTh',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.product.name'),
            inputProp: () => ({ value: modelRef.refCompanyProduct?.refProduct?.nameTh, disabled: true })
        }),
        createFieldDate({
            key: 'refSamplingRequest.samplingCollectDate',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingRequest.samplingCollectDate'),
            inputProp: () => ({
                value: modelRef.refSamplingRequest?.samplingCollectDate,
                disabled: true
            })
        }),
        createFieldInputNumber({
            key: 'samplingAmount',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingAmount'),
            inputProp: () => ({
                value: modelRef.samplingAmount,
                'onUpdate:value': value => modelRef.samplingAmount = value,
                disabled: disabled
            })
        }),
        createFieldInput({
            key: 'productCodeCompany',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProduct.productCodeCompany'),
            inputProp: () => ({
                value: modelRef.productCodeCompany,
                'onUpdate:value': value => modelRef.productCodeCompany = value,
                disabled: disabled
            })
        }),
    ]
}

export const createFieldOfficer2 = ({ props, data }) => {
    const viewOnly = props.viewOnly
    const disabled = viewOnly || disabledChecker({ props, data, viewOnly, key: 'officerSection' })
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        {
            visible: () => modelRef.isMicroExt || modelRef.isChemiExt,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div class="my-2 ml-4"><u>{i18n.global.t('model.samplingProduct.labels.sendExtLab')}</u></div>
        },
        createFieldSelect({
            visible: () => modelRef.isMicroExt,
            key: 'refLabMicroExt',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProduct.labels.microExtLabName'),
            inputProp: () => ({
                value: getAnalysis({ modelRef, refLabTypeKey: "labMicro", refExtCenterTypeKey: "Lab Ext" })?.refLabExt,
                disabled: true,
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/labExt/cacheFindAll', { searchQuery, labType: "isMicro" }),
                renderLabel: ({ item }) => <div>{item.nameTh}</div>,
            }),
        }),
        createFieldInputNumber({
            visible: () => modelRef.isMicroExt,
            key: `microExtSamplingSendAmount`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProduct.microExtSamplingSendAmount'),
            inputProp: () => ({
                value: modelRef.microExtSamplingSendAmount,
                'onUpdate:value': value => modelRef.microExtSamplingSendAmount = value,
                disabled: disabled
            })
        }),
        createFieldSelect({
            visible: () => modelRef.isChemiExt,
            key: 'refLabChemiExt',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProduct.labels.chemiExtLabName'),
            inputProp: () => ({
                value: getAnalysis({ modelRef, refLabTypeKey: "labChemi", refExtCenterTypeKey: "Lab Ext" })?.refLabExt,
                disabled: true,
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/labExt/cacheFindAll', { searchQuery, labType: "isChemi" }),
                renderLabel: ({ item }) => <div>{item.nameTh}</div>,
            }),
        }),
        createFieldCheckbox({
            visible: () => modelRef.isMicroExt && modelRef.isChemiExt,
            key: 'isSameSendAmountExt',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => ' ',
            inputProp: () => ({
                checked: modelRef.isSameSendAmountExt,
                'onUpdate:checked': checked => {
                    modelRef.isSameSendAmountExt = checked
                    modelRef.chemiExtSamplingSendAmount = null
                },
                disabled: disabled,
                text: () => i18n.global.t(`model.samplingProduct.isSameSendAmountExt`),
            })
        }),
        createFieldInputNumber({
            visible: () => modelRef.isChemiExt,
            key: `chemiExtSamplingSendAmount`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProduct.chemiExtSamplingSendAmount'),
            inputProp: () => ({
                value: modelRef.chemiExtSamplingSendAmount,
                'onUpdate:value': value => modelRef.chemiExtSamplingSendAmount = value,
                disabled: modelRef.isSameSendAmountExt || disabled
            })
        }),
    ]
}
*/

export const getAnalysis = ({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq }) => {
    const analysis = modelRef.analysiss?.find(d => d.refLabType?.key === refLabTypeKey && d.refExtCenterType?.key == refExtCenterTypeKey && d.labExtSeq == labExtSeq)
    if (!analysis && refExtCenterTypeKey) {
        const parent = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey: null, labExtSeq: null })
        return parent?.transferTos?.find(d => d.refLabType?.key === refLabTypeKey && d.refExtCenterType?.key == refExtCenterTypeKey && d.labExtSeq == labExtSeq)
    }
    return analysis
}



export const onUpdateFieldCheckbox = ({data, key, refLabTypeKey, refExtCenterTypeKey, labExtSeq, modelRef, checked }) => {
    modelRef[key] = checked
    const keyLab = refLabTypeKey?.replaceAll('lab', 'is')
    if (!checked && !modelRef[`${keyLab}Display`] && !modelRef[`${keyLab}Ext`] && !modelRef[`${keyLab}Ext2`]) {
        modelRef[keyLab] = false
    }
    const analysisForm = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })
    if (checked && !analysisForm) {
        createFormAnalysis({ modelRef, data, refLabTypeKey, refExtCenterTypeKey, labExtSeq })
        // if (!refExtCenterTypeKey && !labExtSeq) {
        //     const where = [];
        //     const sort = [{ name: "updateDate", type: "desc"}]
        //     if (key === 'isPhysic') {
        //         const options = { force: true };
        //         where.push({name: "refLabTopic.refParent.id", type: "UUID", operator: '=', value: null });
        //         where.push({name: "refProductType.id", type: "UUID", operator: '=', value:  modelRef.refCompanyProduct?.refProduct?.refProductType?.id })
        //         callSearchLabTopicMethod({ refLabTypeKey, where, options }).then((items) => items.map(item => form.topics.push({ refLabTopic: item.refLabTopic })))
        //     } else {
        //         callSearchAllLabTopicByProductIdAndCounties({ labTypeKey: refLabTypeKey, productId: modelRef.refCompanyProduct?.refProduct?.id, countryId1: modelRef.refCompanyCountry1?.refCountry?.id, countryId2: modelRef.refCompanyCountry2?.refCountry?.id, where, sort }).then((items) => items.map(item => form.topics.push({ refLabTopic: item.refLabTopic })))
        //     }
        // }
    } else if (checked && analysisForm) {
        analysisForm.isDelete = false
    } else if (!checked && analysisForm) {
        analysisForm.isDelete = true
        if (!analysisForm.id) {
            const index = modelRef.analysiss?.findIndex(d => d.refLabType?.key === refLabTypeKey && d.refExtCenterType?.key == refExtCenterTypeKey && d.labExtSeq == labExtSeq)
            if (index > -1) {
                if (modelRef.analysiss?.[index]?.transferTos?.filter(d=>!d.isDelete)?.length === 0) {
                    modelRef.analysiss.splice(index, 1);
                } else {
                    analysisForm.isDelete = false
                }
            }
        } else {
            if (!refExtCenterTypeKey) {
                analysisForm.isDelete = false
            }
        }
        if (refExtCenterTypeKey) {
            const parent = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey: null, labExtSeq: null })
            if (!modelRef[`${keyLab}Display`] && parent?.transferTos?.filter(d=>!d.isDelete)?.length === 0) {
                parent.isDelete = true;
            }
        }
    }

    if (refExtCenterTypeKey) {
        const parent = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey: null, labExtSeq: null })
        if (parent) { parent.isSave = true }
    }
}

export const createFieldAnalysis = ({ props, data, key, refExtCenterTypeKey, labExtSeq, refLabTypeKey, label }) => {
    const viewOnly = props.viewOnly
    const disabled = viewOnly || disabledChecker({ props, data, viewOnly, key: 'section' })
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        createFieldToolTipCheckbox({
            key: key,
            colProp: () => ({ xs: 24, md: 12, lg: 10 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
            label: () => label || ' ',
            inputProp: () => {
                return {
                    checked: modelRef[key],
                    'onUpdate:checked': checked => {
                        if (key?.indexOf('Ext') > -1 && !(modelRef[key.replaceAll('Ext', '')] || modelRef[key.replaceAll('Ext2', '')])) {
                            onUpdateFieldCheckbox({data, key: key.replaceAll(/(Ext|2)/g, ''), refLabTypeKey, refExtCenterTypeKey: null, labExtSeq: null,  modelRef, checked })
                        }
                        onUpdateFieldCheckbox({data, key, refLabTypeKey, refExtCenterTypeKey, labExtSeq, modelRef, checked })
                        if(key?.indexOf('Ext') > -1) {
                            modelRef[key.replaceAll(/(Ext|2)/g, '')] = modelRef[key.replaceAll('Ext', '')] || modelRef[key.replaceAll('Ext2', '')]
                        } else {
                            modelRef[key.replaceAll("Display", '')] =  modelRef[key.replaceAll('Display', '')] || modelRef[key]
                        }
                    },
                    disabled: disabled
                        || getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.topics.filter(d => !d.isDelete).length > 0
                        || !(modelRef.refCountry1 || modelRef.refCountry2)
                        || (labExtSeq?.toString() && getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.refLabExt)
                        || (labExtSeq?.toString() && modelRef[key + (labExtSeq + 1)])
                        || (labExtSeq > 1 && ((getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq: labExtSeq - 1 })?.topics.filter(d => !d.isDelete).length || 0) == 0 && !modelRef[key])),
                    text: () => `${i18n.global.t(`model.samplingProduct.${key}`)} : `,
                    tooltip: () => getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.topics.filter(d => !d.isDelete).length > 0 ? i18n.global.t(`model.samplingProduct.labels.uncheck`) : undefined,
                    placement: 'left'
                }
            }
        }),
        createFieldSelect({
            visible: () => {
                return refExtCenterTypeKey && modelRef[key] && getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.topics
            },
            key: 'refLabExt',
            colProp: () => ({ xs: 24, md: 6, lg: 6 }),
            formItemProp: () => ({ labelCol: { xs: 0 }, wrapperCol: { xs: 24 } }),
            inputProp: () => ({
                value: getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq }).refLabExt,
                'onUpdate:value': value => getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq }).refLabExt = value,
                disabled: disabled,
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/labExt/cacheFindAll', { searchQuery, labType: key?.replace(2,"") }).then(labExts => {
                    if (labExtSeq > 1) {
                        const fistLabExt = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq: 1 }).refLabExt
                        return labExts.filter(labExt => labExt.id != fistLabExt.id)
                    } else {
                        return labExts;
                    }
                }),
                renderLabel: ({ item }) => <div>{item.nameTh}</div>,
                placeholder: i18n.global.t(`model.samplingProductAnalysis.labels.selectLabExt`),
            }),
            changeLog: { getValue: ({ record }) => record.refLabExt?.nameTh }
        }),
        createFieldSelect({
            visible: () => modelRef[key.replaceAll('Display', '')] && getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.topics
                && (refExtCenterTypeKey == null || getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.refLabExt?.labExtTopics?.length > 0),
            key: `analysiss`,
            colProp: () => ({ xs: 24, md: refExtCenterTypeKey ? 6 : 12, lg: refExtCenterTypeKey ? 8 : 14 }),
            formItemProp: () => ({ labelCol: { xs: 0 }, wrapperCol: { xs: 24 } }),
            inputProp: () => ({
                value: getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq }).topics,
                'onUpdate:value': () => {
                    const analysis = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })
                    analysis.isSave = true
                    analysis?.topics?.forEach((d) => (d.isTransfer = refExtCenterTypeKey != null))
                    if (refExtCenterTypeKey) {
                        getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey: null, labExtSeq: null }).isSave = true;
                    }
                    modelRef.isSave = true
                },
                disabled: disabled || !modelRef[key.replaceAll('Display', '')] || !(modelRef.refCountry1 || modelRef.refCountry2),
                list: ({ searchQuery }) => {
                    const analysis = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey: null, labExtSeq: null })
                    const analysisExt1 = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey: 'Lab Ext', labExtSeq: 1})
                    const analysisExt2 = getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey: 'Lab Ext', labExtSeq: 2})
                    const labTopicInIds = (!analysis ||analysis?.isDelete) ? [] : analysis?.topics?.filter(d => !d.isDelete).map(d => d.refLabTopic?.id)
                    const labTopicExt1Ids = (!analysisExt1 ||analysisExt1?.isDelete) ? [] : analysisExt1?.topics?.filter(d => !d.isDelete).map(d => d.refLabTopic?.id)
                    const labTopicExt2Ids = (!analysisExt2 ||analysisExt2?.isDelete) ? [] : analysisExt2?.topics?.filter(d => !d.isDelete).map(d => d.refLabTopic?.id)
                    let labTopicAllIds = [...labTopicInIds, ...labTopicExt1Ids, ...labTopicExt2Ids]
                    // Where Lab Topic In Standard
                    const where = []
                    const sort = [{ name: "updateDate", type: "desc"}]
                    const options = { force: true };
                    if (labTopicAllIds?.length) { where.push({name: "id", type: "UUID", isNot: true, operator: 'in', value: labTopicAllIds }) }
                    // --- Config For Go-Live Version  data.isCountryStdTopic == False --- //
                    if (data.isCountryStdTopic) {
                        // Not Used For Now Every Case In El
                        if (refLabTypeKey === 'isPhysic') {
                            where.push({name: "refLabTopic.refParent.id", type: "UUID", operator: '=', value: null });
                            where.push({name: "refProductType.id", type: "UUID", operator: '=', value:  modelRef.refCompanyProduct?.refProduct?.refProductType?.id })
                            return callSearchLabTopicMethod({ refLabTypeKey, where, options }).then((items) => items.map(item => ({ refLabTopic: item.refLabTopic }) ))
                        } else {
                            return callSearchAllLabTopicByProductIdAndCounties({ searchQuery, labTypeKey: refLabTypeKey, productId: modelRef.refCompanyProduct?.refProduct?.id, countryId1: modelRef.refCountry1?.refCountry?.id, countryId2: modelRef.refCountry2?.refCountry?.id, where, sort })
                                .then((items) => {
                                    if (refExtCenterTypeKey) {
                                        return items.filter(item => getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.refLabExt?.labExtTopics.find(LabExtTopic => LabExtTopic.refLabTopic?.id == item.id))
                                    } else {
                                        return items
                                    }
                                })
                                .then((items) => items.map(item => ({ refLabTopic: item })))
                        }
                    } else {
                        if (props.isRepeat) {
                            const analysis = getAnalysis({ modelRef: modelRef.refParent, refLabTypeKey, refExtCenterTypeKey: null, labExtSeq: null })
                            const rejectLabTopicInIds = analysis?.topics?.filter(d => !d.isDelete && d.refTopicAnalysisStatus.key == 'Reject').map(d => d.refLabTopic?.id)
                            return store.dispatch('resource/v1/master/labTopic/cacheFindAll', { searchQuery, labTypeKey: refLabTypeKey, where, options })
                                .then((items) => {
                                    if (refExtCenterTypeKey) {
                                        return items.filter(item => getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.refLabExt?.labExtTopics.find(LabExtTopic => LabExtTopic.refLabTopic?.id == item.id))
                                    } else {
                                        return items
                                    }
                                })
                                .then((items) => items.filter(item => rejectLabTopicInIds.find(rejectTopicId => rejectTopicId == item.id)).map(topicReject => ({ refLabTopic: topicReject })))

                        } else {
                            return store.dispatch('resource/v1/master/labTopic/cacheFindAll', { searchQuery, labTypeKey: refLabTypeKey, where, options })
                                .then((items) => {
                                    if (refExtCenterTypeKey) {
                                        return items.filter(item => getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.refLabExt?.labExtTopics.find(LabExtTopic => LabExtTopic.refLabTopic?.id == item.id))
                                    } else {
                                        return items
                                    }
                                })
                                .then((items) => items.filter(topic => topic.refParent == null).map(item => ({ refLabTopic: item })))
                        }
                    }
                },
                optKey: 'refLabTopic.id',
                renderLabel: ({ item }) => {
                    const prefix = item?.refLabTopic?.name;
                    let suffix = ''
                    if (item?.refLabTopic?.refLabType?.key != 'labPhysic') {
                        suffix = ' (' + item?.refLabTopic?.refLabTopicUnit?.value + ') [n = ' + (item?.sub || item?.refLabTopic?.sub) + ']';
                    }
                    return <span>{ prefix + suffix}</span>
                },
                placeholder: i18n.global.t(`model.samplingProductAnalysis.labels.selectTopic`),
                mode: 'multiple',
            }),
            inputRender: ({ field }) => {
                let visible = modelRef[key]
                if(!visible && getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey })?.topics) {
                    return <div></div>
                }
                const placeholder = field?.label?.();
                const inputProp = field?.inputProp?.({ field });
                return <CSelect placeholder={placeholder} {...inputProp}></CSelect>;
            },
            changeLog: { getValueChildren: ({ record }) => record?.name }
        }),
        {
            visible: () => !modelRef[key.replaceAll('Display', '')] || !getAnalysis({ modelRef, refLabTypeKey, refExtCenterTypeKey, labExtSeq })?.topics,
            colProp: () => ({ xs: 24, md: !refExtCenterTypeKey ? 12 : 6, lg: !refExtCenterTypeKey ? 14 : 8 }),
            formItemRender: () => <span></span>,
        },
    ]
}

export const createFormTitle = () => {
    return i18n.global.t('model.samplingProduct.modelName')
}

export const createFormTitleOfficer = () => {
    return i18n.global.t('views.section.officer')
}

export const loadForm = ({ props, data }) => {
    setIsLoading(true)
    const { form } = props
    const { id, useForm } = data
    const { modelRef } = useForm
    let promise = null
    if (form) {
        promise = Promise.resolve({ data: [form] })
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) })
    } else {
        promise = Promise.resolve({ data: [modelRef] })
    }
    return promise
        .then(page => initUseForm({ data, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data }))
        .finally(() => setIsLoading(false))
}

export const initState = ({ props, isNotVisibleCreate }) => {
    const { menuContext, refSamplingRequestTypeKey } = props
    state.columns = createColumns({ props }),
    state.manages = [
        createManageSelect({
            menuContext,
            type: window.selectType,
        }),
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) => onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: (search) => onSearch({ props, ...search }), setIsLoading }),
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) => onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: (search) => onSearch({ props, ...search }), setIsLoading }),
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) => onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: (search) => onSearch({ props, ...search }), setIsLoading }),
        }),
        createManageExportCsv({ menuContext }),
    ]

    // state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix: 'sampling-requests' }) })]
    state.manageExtras = []
    if(!isNotVisibleCreate) {
        state.manageExtras.push(createManageExtraCreate({ menuContext, onClick: () => {
            const routerPrefix = refSamplingRequestTypeKey?.includes("M") ? "sampling-monitors" : "sampling-requests";
            onClickCreate({ routerPrefix: routerPrefix })
        }}))
    }
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => {
            const routerPrefix = refSamplingRequestTypeKey?.includes("M") ? "sampling-monitors" : "sampling-requests";
            onClickView({ record: record?.refSamplingRequest, routerPrefix })
        }}),
        // createRowActionEdit({ menuContext, onClick: ({ record }) => onClickEdit({ record: record?.refSamplingRequest, routerPrefix: 'sampling-requests' }) }),
    ]

}

export const ruleChecker = ({ props, data }) => {
    const { menuContext, parent } = props
    const { useForm } = data
    const { modelRef } = useForm
    if (have({ menuContext, keys: ['forReceiver', 'forLabSender'] })) {
        if (['Approve'].includes(parent.refSamplingStatus?.key)) {
            addRules({ useForm, modelRef, key: 'refSamplingRequest.samplingCollectDate', rules: [required] })
            addRules({ useForm, modelRef, key: 'samplingAmount', rules: [required] })
            addRules({ useForm, modelRef, key: 'samplingAmountMicro', rules: [requiredWhen({ when: () => (modelRef.isMicro && !modelRef.isMicroExt) || modelRef.isMicroDisplay })] })
            addRules({ useForm, modelRef, key: 'samplingAmountChemi', rules: [requiredWhen({ when: () => (modelRef.isChemi && !modelRef.isChemiExt) || modelRef.isChemiDisplay })] })
            addRules({ useForm, modelRef, key: 'samplingAmountPhysic', rules: [requiredWhen({ when: () => modelRef.isPhysic })] })
            addRules({ useForm, modelRef, key: 'samplingAmountMicroExt1', rules: [requiredWhen({ when: () => modelRef.isMicroExt })] })
            addRules({ useForm, modelRef, key: 'samplingAmountMicroExt2', rules: [requiredWhen({ when: () => modelRef.isMicroExt2 })] })
            addRules({ useForm, modelRef, key: 'samplingAmountChemiExt1', rules: [requiredWhen({ when: () => modelRef.isChemiExt && !modelRef.isSameSendAmountExt1 })] })
            addRules({ useForm, modelRef, key: 'samplingAmountChemiExt2', rules: [requiredWhen({ when: () => modelRef.isChemiExt2 && !modelRef.isSameSendAmountExt2 })] })
            addRules({ useForm, modelRef, key: 'productCodeCompany', rules: [required] })
            /*
            if (modelRef.isMicroExt) { addRules({ useForm, modelRef, key: 'microExtSamplingSendAmount', rules: [required] }) }
            if (modelRef.isChemiExt) { addRules({ useForm, modelRef, key: 'chemiExtSamplingSendAmount', rules: [required] }) }
            watch(
                () => modelRef.isSameSendAmountExt,
                () => {
                    if (modelRef.isSameSendAmountExt) {
                        addRules({ useForm, modelRef, key: 'chemiExtSamplingSendAmount', rules: [] })
                    } else {
                        addRules({ useForm, modelRef, key: 'chemiExtSamplingSendAmount', rules: [required] })
                    }
                },
                { flush: 'post' }
            )
            */
        }
    }
}

export const disabledChecker = ({ props, data, key }) => {
    const { menuContext, parent } = props
    let disabledStatus = true

    if (!key) {
        // for section and list checker
        if (has({ menuContext, key: 'forCompany' })) {
            data.invisibleOfficerSection = true
        }

        if (have({ menuContext, keys: ['forReceiver', 'forLabSender'] })) {
            data.disabledSection = true
            if (!parent?.refSamplingStatus || ['Draft', 'Wait'].includes(parent?.refSamplingStatus?.key)) {
                data.invisibleOfficerSection = true
            }
        }
    } else {

        if (has({ menuContext, key: 'forCompany' })) {
            if (!parent?.refSamplingStatus || ['Draft', 'Wait', 'Reject'].includes(parent?.refSamplingStatus?.key)) {
                const enableAllIgnore = []
                disabledStatus = enableAllIgnore.includes(key)
            }
        }

        if (have({ menuContext, keys: ['forReceiver', 'forLabSender'] })) {
            if (['Approve'].includes(parent.refSamplingStatus?.key)) {
                const disableAllIgnore = ['officerSection']
                disabledStatus = disabledStatus && !disableAllIgnore.includes(key)
            }
        }

        // if (props.isRepeat) {
        //     disabledStatus = true
        // }
    }
    return disabledStatus
}

export const loadDefaultForm = ({ data }) => {
    const promises = []
    promises.push(Promise.all([callLookupStatus(), callLookupLabTypes(), callExtCenterTypes()])
        .then(arr => {
            data.statuses = arr[0]
            data.labTypes = arr[1]
            data.extCenterTypes = arr[2]
        }))
    return Promise.all(promises)
}

export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs })
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    data.fieldsOfficer = createFieldOfficer({ props, data, refs });
    data.fieldsOfficer2 = createFieldOfficer2({ props, data, refs });
    loadForm({ props, data, refs })
        .then(() => {
            if (props.setAppPageHeader) {
                setAppPageHeader({
                    slots: {
                        top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                        default: () => createAppPageHeaderDefault({ props, data, refs })
                    }
                });
            }
        })
        .then(() => ruleChecker({ props, data }))
        .then(() => disabledChecker( { props, data, viewOnly: props.viewOnly }))
}

export const createAppPageHeaderDefault = ({ props, data }) => {
    const col1 = []
    const col2 = []
    const { menuContext, viewOnly } = props
    const { id, isActive } = data.useForm.modelRef
    if (id && has({ menuContext, key: 'canCreate' })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && has({ menuContext, key: 'canView' })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: 'm-1' }))
    }
    if (viewOnly && id && isActive && has({ menuContext, key: 'canEdit' })) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: 'm-1' }))
    }
    if (!viewOnly && (!id || (id && isActive))) {
        col1.push(createButtonSave({ onClick: () => onClickSave({ data }), classStyle: 'm-1' }))
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: 'canActive' })) {
        col2.push(createButtonActive({ onClick: () => onClickActive({ record: { id }, callActive, setIsLoading: setIsLoadingApp, onClickEdit: () => onClickEdit({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canArchive' })) {
        col2.push(createButtonArchive({ onClick: () => onClickArchive({ record: { id }, callArchive, setIsLoading: setIsLoadingApp, onClickView: () => onClickView({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canDelete' })) {
        col2.push(createButtonDelete({ onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }), classStyle: 'm-1' }))
    }
    return <Row type="flex">
        <Col>{col1}</Col>
        <Col class="ml-auto">{col2}</Col>
    </Row>
}

export const openModalList = ({ bind, onIframeMounted, isNotVisibleCreate }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => <CIFrame src={`${process.env.VUE_APP_PUBLIC_PATH}/app/sampling/sampling-products?isLayout=false&canSelect=true&cacheQuery=true${isNotVisibleCreate?'&isNotVisibleCreate=true':''}`} onIframeMounted={({ refs }) => onIframeMounted({ options, refs })}></CIFrame>
    })
    return options
}

export const openModalForm = ({ props, items, isGenSamplingNo }) => {
    const refs = reactive({ form: null })
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            okButtonProps: { disabled: props.viewOnly },
            header: i18n.global.t('model.samplingProduct.modelName'),
            onOk: () => {
                refs.form.callOnClickModalOk({ isGenSamplingNo })
                    .then((record) => {
                        if (items) {
                            items.push(record)
                        } else {
                            lodash.mergeWith(props.form, record, (objValue, srcValue) => {
                                if (Array.isArray(objValue)) {
                                    return srcValue
                                }
                            })
                        }
                        options.bind.onCancel()
                    })
            }
        }),
        render: () => <SamplingProductForm ref={(e) => { if (e) refs.form = e }} {...props}></SamplingProductForm>
    })
    return options
}

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, parent } = props
    const disabled = viewOnly || have({ menuContext, keys: ['forReceiver', 'forLabSender'] })
    data.columns = createColumns({ props })
    data.page = createPage({ data: props.parent.samplingProducts })
    data.tableOptions = { search: { activeKey: null } }
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => disabled ? false : has({ menuContext, key: 'canDelete' }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, items: props.parent.samplingProducts }),
        }),
        createManageExportCsv({ menuContext }),
    ]
    data.manageExtras = []
    data.rowActions = []

    const canDeleteChecker = (!parent?.id || ['Draft', 'Reject'].includes(parent?.refSamplingStatus?.key) || have({ menuContext, keys: ['forReceiver', 'forLabSender'] })) && (!['Send Lab', 'Review Result', 'Cancel', 'Done'].includes(parent?.refSamplingStatus?.key))
    if (canDeleteChecker) {
        data.rowActions.push(createRowActionDelete({
            menuContext,
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.delete") }),
                    autoFocusButton: "cancel",
                    okType: "danger",
                    onOk: () => {
                        onClickDeleteAllClient({
                            rowSelection: { selectedRows: [record] },
                            items: parent.samplingProducts
                        })
                    }
                });
            }
        }));
    }

    if (menuContext) {
        if (!disabled) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => {
                            props.useForm.validate(['refSamplingRequestType'])
                                .then(() => {
                                    openModalForm({ props: { menuContext, viewOnly: disabled, setAppPageHeader: false, form: {}, parent, isRepeat: props.isRepeat }, items: props.parent.samplingProducts })
                                })
                                .catch((error) => {
                                    validateError({ error })
                                    throw error
                                })
                         },
                        options: { text: i18n.global.t('button.add') }
                    }),
                }),
                visible: () => has({ menuContext, key: 'canCreate' }),
            })

            data.rowActions.push(createRowActionEdit({ menuContext, onClick: ({ record }) => openModalForm({ props: { menuContext, viewOnly: false, setAppPageHeader: false, form: record, parent, isRepeat: props.isRepeat } }) }))
        } else {
            data.rowActions.push(createRowActionView({ menuContext, onClick: ({ record }) => openModalForm({ props: { menuContext, viewOnly: true, setAppPageHeader: false, form: record, parent, isRepeat: props.isRepeat } }) }))
        }

        if (!viewOnly) {
            data.rowActions.push({
                visible: ({ record }) =>
                    have({ menuContext, keys: ['forReceiver', 'forLabSender'] })
                    && ['Approve'].includes(parent.refSamplingStatus?.key)
                    && ((record.id && record.isActive === true) || !record.id)
                    && (record.samplingNo === 'Draft' || record.refStatus?.key === 'Draft'),
                bind: { class: 'btn-warning', size: 'small', icon: () => <CIcon file="active.svg"></CIcon>, },
                text: () => i18n.global.t('model.samplingProduct.labels.genSamplingNo'),
                onClick: ({ record }) => openModalForm({ props: { menuContext, viewOnly, setAppPageHeader: false, form: record, parent }, isGenSamplingNo : true })
            })

            data.rowActions.push({
                visible: ({ record }) =>
                    have({ menuContext, keys: ['forReceiver', 'forLabSender'] })
                    && ['Approve'].includes(parent.refSamplingStatus?.key)
                    && ((record.id && record.isActive === true) || !record.id)
                    && (record.samplingNo !== 'Draft' && record.refStatus?.key !== 'Draft'),
                bind: { class: 'btn-primary', size: 'small', icon: () => <CIcon file="edit.svg"></CIcon>, },
                text: () => i18n.global.t('button.edit'),
                onClick: ({ record }) => openModalForm({ props: { menuContext, viewOnly, setAppPageHeader: false, form: record, parent }, isGenSamplingNo : true })
            })
        }
    }

    fetchData({ props, data }).then(page => props.parent.samplingProducts.push(...page.data))
}

export const state = reactive({
    page: createPage({ options: { select: ['**', 'refSamplingRequest.refCompany.*', 'refSamplingRequest.refSamplingStatus.*', 'refCompanyProduct.**', 'refCountry1.*', 'refCountry2.*', 'refSamplingRequest.refSamplingRequestType.*', 'refCompanyProduct.refProduct.refProductType.*', 'refSamplingRequest.refLabResultStatus.*'] } }),
    tableOptions: { search: { activeKey: 'Search' } }
})
